import React, { useState } from "react";

import { useParams } from "react-router-dom";
import {
  AddStageRequest,
  CaseStageAction,
  CaseStageEnum,
} from "../../../../../src/api/caseStages";
import { useAppDispatch } from "../../../../../src/app/hooks";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import { showErrorToast, showSuccessToast } from "../../../../lib/toast";
import StageWorkflowConfirmCaseProgressionModal from "../../../stageWorkflow/components/StageWorkflowConfirmCaseProgressionModal";
import { updateCaseStage } from "../../logic/thunks";

export const MarkCompletedWithRemarks: React.FC<{
  next_stage: CaseStageEnum;
}> = ({ next_stage }) => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOpen = () => {
    setIsModalOpen(true)
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleAcceptConfirmFwdCase = async (
    notes?: string,
  ): Promise<void> => {
    if (!caseId) {
      return;
    }

    try {
      setIsLoading(true);

      const request: AddStageRequest = {
        stage: next_stage,
        source_action: CaseStageAction.MARK_COMPLETE_WITH_REMARKS,
        stage_data: {
          notes,
        },
      };

      await dispatch(
        updateCaseStage({
          caseId,
          request,
        }),
      ).unwrap();

      showSuccessToast("Case marked as completed successfully.");
      setIsModalOpen(false);
    } catch (error) {
      showErrorToast("Unable to mark as completed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AcceptButton label="Mark as Completed" onClick={handleOpen} />

      <StageWorkflowConfirmCaseProgressionModal
        isOpen={isModalOpen}
        nextStage={next_stage}
        onClose={handleClose}
        onConfirm={handleAcceptConfirmFwdCase}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};
